module.exports = __webpack_public_path__ + "static/media/brackets.f10bebed.svg";